module.exports = __webpack_public_path__ + "img/gallery11.fd03affb.png";